var win = window;

export var caf = win.cancelAnimationFrame
  || win.mozCancelAnimationFrame
  || function(id){ clearTimeout(id); };



//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/caf.js
// module id = 840
// module chunks = 2